import React, { useEffect, useState } from "react";
import { Library, ExternalLink, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminSeries() {
  const [series, setSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/admin/series")
      .then(({ data }) => setSeries(data || []))
      .catch(() => setSeries([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section
      data-testid="admin-series-card"
      className="mt-14 bg-white border border-[#0B1E36]/10 p-8"
    >
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3 text-[#C5A059]">
          <Library size={16} strokeWidth={1.5} />
          <h2 className="text-[0.7rem] uppercase tracking-[0.28em] font-medium">
            Séries de sermões · somente leitura
          </h2>
        </div>
        <span className="text-[0.68rem] uppercase tracking-[0.22em] text-[#0B1E36]/50">
          CRUD virá na FASE 2
        </span>
      </div>

      {loading ? (
        <div className="flex items-center text-[#6B7280] py-6">
          <Loader2 size={16} className="animate-spin mr-2" /> Carregando…
        </div>
      ) : series.length === 0 ? (
        <p className="text-[#6B7280] text-sm py-4">Nenhuma série cadastrada.</p>
      ) : (
        <ul className="divide-y divide-[#0B1E36]/8">
          {series.map((s) => (
            <li key={s.id} className="py-4 flex items-start gap-4">
              <span className="font-serif-display text-[1.7rem] text-[#C5A059] tabular-nums leading-none flex-shrink-0 w-12 text-right">
                {String(s.series_order).padStart(2, "0")}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-[0.95rem] text-[#0B1E36] font-medium">
                  {s.title}
                  <span
                    className={`ml-3 text-[0.6rem] uppercase tracking-[0.2em] px-2 py-0.5 rounded ${
                      s.published
                        ? "bg-[#C5A059]/15 text-[#C5A059]"
                        : "bg-[#6B7280]/15 text-[#6B7280]"
                    }`}
                  >
                    {s.published ? "Publicado" : "Rascunho"}
                  </span>
                </p>
                <p className="mt-1.5 text-[0.82rem] text-[#6B7280] leading-relaxed">
                  {s.description}
                </p>
                <p className="mt-2 text-[0.7rem] uppercase tracking-[0.22em] text-[#0B1E36]/55">
                  {s.sermon_count} episódios · ordem: {s.series_order}
                </p>
              </div>
              <a
                href={`/series/${s.category_slug}/${s.slug}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[0.66rem] uppercase tracking-[0.22em] text-[#0B1E36]/70 hover:text-[#C5A059] inline-flex items-center gap-1.5 mt-1.5 flex-shrink-0"
                title="Ver série pública"
              >
                Ver
                <ExternalLink size={11} strokeWidth={1.7} />
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
